<div mat-dialog-content>

    <div class="flex flex-col flex-auto min-w-0">
        <div class="bg-card">
            <div class="flex flex-col min-w-0 ml-4">
                <ng-container *transloco="let t">
                </ng-container>
            </div>
            <br>
            <mat-card-content>
                <h5>Datos generales</h5>
                <form [formGroup]="formMember" class="row d-flex justify-content-start align-items-center">
                    <div class="col-sm-12 col-md-12 col-xl-12">
                        <mat-label>Nombre:</mat-label>
                        <mat-form-field>
                            <input id="nombre" matInput [formControlName]="'nombre'">
                            <mat-error *ngIf="formMember.get('nombre').hasError('required')">
                                El primer nombre es requerido
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-xl-12 ">
                        <mat-label>Email:</mat-label>
                        <mat-form-field>
                            <input id="email" matInput [formControlName]="'email'">
                            <mat-error *ngIf="formMember.get('email').hasError('required')">
                                El correo es requerido
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div *ngIf="!modificarDatos" class="col-sm-12 col-md-6 col-xl-6">
                        <mat-label>Contraseña:</mat-label>
                        <mat-form-field>
                            <input id="password" matInput type="password" [formControlName]="'password'" #passwordField>
                            <button mat-icon-button type="button"
                                (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
                                matSuffix>
                                <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
                                    [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                                <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
                                    [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                            </button>
                            <mat-error>
                                La contraseña es requerida
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-6 col-xl-6">
                        <mat-label>Celular:</mat-label>
                        <mat-form-field>
                            <input id="celular" matInput [formControlName]="'celular'">
                            <mat-error *ngIf="formMember.get('celular').hasError('required')">
                                El celular es requerido
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-xl-12">
                        <mat-label>Rol:</mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <mat-select name="rol" placeholder="Seleccione" formControlName="idRol">
                                <mat-option *ngFor="let rol of lstRoles" [value]="rol.id">
                                    {{ rol.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formMember.get('idRol').hasError ('required')"><strong>*Este campo es
                                    obligatorio</strong></mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-xl-12">
                        <mat-label>Empresas:</mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <mat-select name="empresas" multiple placeholder="Seleccione" formControlName="idEmpresas">
                                <mat-option *ngFor="let empresa of lstEmpresas" [value]="empresa.id">
                                    {{ empresa.attributes.razonSocial }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formMember.get('idEmpresas').hasError ('required')"><strong>*Este campo es
                                    obligatorio</strong></mat-error>
                        </mat-form-field>
                    </div>
                </form>

            </mat-card-content>

        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="close(0)">Cerrar</button>
    <button *ngIf="!modificarDatos" mat-flat-button color="accent" [disabled]="!formMember.valid" cdkFocusInitial
        (click)="addMember();">Guardar</button>
    <button *ngIf="modificarDatos" mat-flat-button color="accent" cdkFocusInitial
        (click)="modifyMember();">Actualizar</button>
</div>